import Page from 'components/pages/studio-id/referral'
import requestInit from 'request/studio-id/referral-init'

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params }) {
  try {
    const studioId = parseInt(params.id)
    if (!studioId) throw Error('no id')
    const initData = await requestInit({ studioId })
    if (!initData.studio) throw Error('not valid id')

    return { props: { ...initData }, revalidate: 60 * 30 }
  } catch (err){
    return { notFound: true }
  }
}

export default function Referral(initData) {
  const t = useI18n()
  const { studio } = initData
  const title = t.seo.title('custom', { value: studio.name })
  const ogImage = fetchOgImage(studio)
  return (
    <>
      <C.Head>
        { h.seo({ title })}
        { h.og({ image: ogImage }) }
      </C.Head>
      <Page { ...initData } />
    </>
  )
}

const fetchOgImage = studio => {
  const { bannerUrl, logoUrl } = studio
  if (bannerUrl) return {
    url: bannerUrl,
    width: 1200,
    height: 628
  }

  return {
    url: logoUrl,
    width: 512,
    height: 512
  }
}
